import { render, staticRenderFns } from "./TableTab.vue?vue&type=template&id=5553ceb8&scoped=true"
import script from "./TableTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TableTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableTab.vue?vue&type=style&index=0&id=5553ceb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553ceb8",
  null
  
)

export default component.exports